import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useAdminProfile } from '../lib/admin'

const navItems = [
  { label: 'Dashboard', path: '/admin' },
  { label: 'Pendentes', path: '/admin/pending' },
  { label: 'Usuários', path: '/admin/users' },
  { label: 'Perfil', path: '/admin/profile' },
  { label: 'Configurações', path: '/admin/settings' },
  { label: 'Trocar Senha', path: '/admin/change-password' },
]

function Sidebar() {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <aside className="w-56 flex-shrink-0 border-r border-[var(--color-border)] bg-[var(--color-surface)] p-4">
      <nav className="space-y-1">
        {navItems.map((item) => {
          const active = location.pathname === item.path
          return (
            <button
              key={item.path}
              type="button"
              onClick={() => navigate(item.path)}
              className={`w-full rounded-lg px-3 py-2 text-sm font-medium text-left transition-colors ${
                active
                  ? 'bg-[var(--color-brand-50)] text-[var(--color-brand-700)]'
                  : 'text-[var(--color-text-muted)] hover:bg-[var(--color-surface-subtle)] hover:text-[var(--color-text)]'
              }`}
            >
              {item.label}
            </button>
          )
        })}
      </nav>
    </aside>
  )
}

function AdminHeader() {
  const { user, logout } = useAuth()
  const { data: profile } = useAdminProfile()

  const displayName = profile?.full_name ?? user?.full_name ?? user?.email ?? 'Admin'

  return (
    <header className="sticky top-0 z-20 flex items-center justify-between border-b border-[var(--color-border)] bg-[var(--color-surface)] px-6 py-3 shadow-sm">
      <h1 className="text-lg font-bold text-[var(--color-text)]">FinApp Admin</h1>
      <div className="flex items-center gap-3">
        <span className="text-sm text-[var(--color-text-muted)]">{displayName}</span>
        <button
          type="button"
          onClick={logout}
          className="rounded-lg border border-[var(--color-border)] bg-white px-3 py-1.5 text-sm font-medium text-[var(--color-text)] transition-colors hover:bg-[var(--color-surface-subtle)] hover:border-[var(--color-border-strong)]"
        >
          Sair
        </button>
      </div>
    </header>
  )
}

export default function AdminLayout() {
  return (
    <div className="min-h-screen flex bg-[var(--color-surface-subtle)]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <AdminHeader />
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
